import classes from "./placeholder.module.scss";

export const MultiMediaCardPlaceholder = () => {
    return (
        <div
            className={classes.mediaCardPlaceholder}
            data-testid="multi-media-card-placeholder"
        >
            <div className={classes.mediaCardPlaceholderImage} />
            <div className={classes.mediaCardPlaceholderHeadlineContainer}>
                <div className={classes.mediaCardPlaceholderText} />
                <div className={classes.mediaCardPlaceholderText} />
            </div>
        </div>
    );
};
